export default function handler (container, link) {
  let tags = container.querySelectorAll('blockquote') || []
  Array.from(tags).forEach(ele => {
    let html = ele.innerHTML
    if (html && html.includes('来源') && ele.querySelector('a')) {
      let wrapper = document.createElement('news-source')
      let [source, url] = html.match(/(href=".*?")|(来源：.*?<)/gi)
      source && (source = source.slice(3, -1))
      url && (url = url.slice(6, -1))
      wrapper.dataset.source = source
      wrapper.dataset.url = url
      ele.parentElement.insertBefore(wrapper, ele)
      ele.remove()
    }
  });
}